// 登入方式選擇
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import Image from 'next/image';

const LOGIN_PROVIDERS = {
    APPLE: 'apple',
    GOOGLE: 'google',
    EMAIL: 'email',
};

const THIRD_PARTY_LOGIN_PROVIDERS = [LOGIN_PROVIDERS.APPLE, LOGIN_PROVIDERS.GOOGLE];

const LoginSelect = ({ setShowMail, t }) => {
    // 會員系統網址
    const { memberUrl, urlQuery } = useSelector(urlState);

    //   按下登入
    const onSignIn = async (provider) => {
        // 第三方登入
        if (THIRD_PARTY_LOGIN_PROVIDERS.includes(provider))
            window.location = `/api/v1/auth/signin/${provider}?originalUrl=${window.location.href}${
                urlQuery ? `${urlQuery}` : ''
            }`;
    };

    return (
        <div className="w-full space-y-[28px] text-center">
            <div className="img-box w-[218px] h-[59px] mx-auto">
                <Image
                    width={218}
                    height={59}
                    src="/images/layout/login_logo.svg"
                    alt="logo"
                    sizes="200px"
                />
            </div>

            <p className="text-black9 text-btn1 opacity-[.8] !mt-[34px]">{t('SELECT_PLATFORM')}</p>

            <div
                className="space-y-[12px] [&>button]:border-1 [&>button]:rounded-[100px] [&>button]:w-full [&>button]:border-[rgba(173,173,173,0.24)]
                [&>button]:trans [&>button]:py-[14px] [&>button]:px-[30px] [&>button]:between-center text-btn1 text-black9 [&_img]:trans"
            >
                {/* google 登入 */}
                <button
                    className="gtm-btn-login-google hover:bg-[#CA5040] hover:border-[#CA5040] hover:text-white group"
                    onClick={() => onSignIn('google')}
                >
                    <Image
                        className="group-hover:filter-fff"
                        width={20}
                        height={20}
                        src="/images/icon/icon_google.svg"
                        alt="google"
                    />
                    Google
                    <span className="w-[20px]" />
                </button>

                {/* apple 登入 */}
                <button
                    className="gtm-btn-login-apple hover:bg-black9 hover:border-black9 hover:text-white group"
                    onClick={() => onSignIn('apple')}
                >
                    <Image
                        className="dark:filter-fff group-hover:filter-fff"
                        width={20}
                        height={20}
                        src="/images/icon/icon_apple.svg"
                        alt="apple"
                    />
                    Apple
                    <span className="w-[20px]" />
                </button>

                {/* 信箱登入 */}
                <button
                    onClick={() => setShowMail(true)}
                    className="gtm-btn-login-email hover:bg-[rgba(177,128,199,.16)] hover:border-transparent"
                >
                    <Image width={20} height={20} src="/images/icon/icon_mail.svg" alt="mail" />
                    Email
                    <span className="w-[20px]" />
                </button>
            </div>

            <p className="text-center text-black text-btn2 space-x-[10px]">
                <span>{t('AGREE')}</span>

                {/* 另開服務條款 */}
                <a
                    href={memberUrl + '/terms-of-service'}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="text-vPurple underline decoration-vPurple trans hover:text-purple hover:decoration-purple"
                >
                    {t('TERMS')}
                </a>
            </p>
        </div>
    );
};

export default LoginSelect;
